import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// web/src/components/ui/GroundedBadge.tsx
// Green "Grounded" badge shown when reasoning trace has non-empty knowledge_used.
// Adaptive: only visible to users with Argus sophistication ≥ SOPHISTICATION_THRESHOLD.
// If sophistication is not provided, badge is always shown (default-visible).
import { SOPHISTICATION_THRESHOLD } from "../../lib/displayConfig";
export function GroundedBadge({ knowledgeUsed = [], sophistication, className = "", }) {
    // Don't show if no knowledge was used
    if (!knowledgeUsed || knowledgeUsed.length === 0)
        return null;
    // Adaptive: hide from novice users (sophistication known and < threshold)
    if (sophistication !== undefined && sophistication < SOPHISTICATION_THRESHOLD)
        return null;
    return (_jsxs("span", { className: `inline-flex items-center gap-1 text-[10px] font-medium text-emerald-400 ${className}`, title: `Grounded in ${knowledgeUsed.length} verified source${knowledgeUsed.length !== 1 ? "s" : ""}`, children: [_jsx("span", { className: "w-1.5 h-1.5 rounded-full bg-emerald-400 shrink-0" }), "Grounded"] }));
}
